/*********************************************************
 *                  Operators Ctrl
 *
 ********************************************************/


"use strict";

angular.module("exploitation")

	.controller("OperatorsEditCtrl", [
		"$scope", "$location", "Utils", "operator", "editMode", "$uibModal", "OperatorsService", "toastr",
		function ($scope, $location, Utils, operator, editMode, $uibModal, OperatorsService, toastr) {

		/************************************************************************************************************
         *  SETUP
         *************************************************************************************************************/

		$scope.data = {
			operator: operator.data,
			editMode: editMode
		};

		$scope.post = function () {

			if ($scope.data.editMode === true) {
				OperatorsService.edit($scope.data.operator).then((response) => {
					const data = response.data;
					toastr.success("", "Opérateur " + data.name + " mis à jour");
					$scope.data.operator = data;
				}).catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la mise à jour de l'opérateur. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			} else  {
				OperatorsService.addOperateur($scope.data.operator).then(() => {
					toastr.success("", "Opérateur créé");
					$location.path("/data-management/operators");
				}).catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la création de l'opérateur. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			}
		};
	}]);